import styled from 'styled-components';
import { Card, Flex, token } from '@zillow/constellation';

export const StyledContentDiv = styled.div`
  min-height: 60px;
`;

export const StyledFlex = styled(Flex)<{ overflow?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: inherit;

  /* to handle long error messages */
  overflow: ${(props) => props.overflow};
`;

export const StyledCard = styled(Card)`
  min-height: 200px;
`;

export const StyledHR = styled.div`
  flex-grow: 0;
  margin-bottom: 15px;
  border-bottom: 1px solid ${token('colors.gray300')};
  border-right: none;
`;
